<template>
  <div class="main">
    <div class="margin">
      <!--<div class="header">-->
      <span class="title" style="font-size: 30px !important;">megaWms</span>
      <!--</div>-->
      <vxe-tabs
        v-model="customActiveKey"
        padding
        size="medium"
        style="margin-top:24px"
        @change="handleTabClick"
      >
        <vxe-tab-pane :title="$t('tab.loginTab')" name="tab1" titleAlign="center" titleWidth="100%">
          <vxe-form ref="formLogin" :data="user" size="medium" span="24" @submit="handleSubmit">
            <vxe-form-item field="username">
              <vxe-input v-model="user.username" autoComplete="username" name="username" placeholder="placeholder.account" prefix-icon="vxe-icon-user" style="width: 100%"/>
            </vxe-form-item>
            <vxe-form-item field="password">
              <vxe-input v-model="user.password" name="password" placeholder="placeholder.password" prefix-icon="vxe-icon-lock" style="width: 100%" type="password"/>
            </vxe-form-item>

            <vxe-form-item>
              <vxe-button
                :disabled="state.loginBtn"
                :loading="state.loginBtn"
                content="button.login"
                icon="vxe-icon-click-button"
                status="primary"
                style="width: 100%"
                type="submit"
              />
            </vxe-form-item>
          </vxe-form>
        </vxe-tab-pane>
      </vxe-tabs>
    </div>

    <two-step-captcha
      v-if="requiredTwoStepCaptcha"
      :visible="stepCaptchaVisible"
      @success="stepCaptchaSuccess"
      @cancel="stepCaptchaCancel"
    />
  </div>
</template>

<script>
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { mapActions } from 'vuex'
import { getSmsCaptcha } from '@/api/login'
import Vue from 'vue'
import { ACCESS_TOKEN, ENTERPRISE, OPERATOR, WAREHOUSE } from '@/store/mutation-types'

export default {
  components: {
    TwoStepCaptcha
  },
  data() {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      loginType: 0,
      isLoginError: false,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        loginType: 0,
        smsSendBtn: false
      },
      no: '',
      user: { username: '', password: '' }
    }
  },
  created() {
    // get2step({ })
    //   .then(res => {
    //     this.requiredTwoStepCaptcha = res.result.stepCode
    //   })
    //   .catch(() => {
    //     this.requiredTwoStepCaptcha = false
    //   })
    // this.requiredTwoStepCaptcha = true
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      const { state } = this
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    handleTabClick(key) {
      this.customActiveKey = key
      // this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        customActiveKey,
        Login
      } = this
      state.loginBtn = true
      Vue.ls.remove(ACCESS_TOKEN)
      const validateFieldsKey = customActiveKey === 'tab1' ? [this.user.username, this.user.password] : ['mobile', 'captcha']
      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          const loginParams = { ...values }
          delete loginParams.username
          loginParams.username = this.user.username
          loginParams.password = this.user.password
          loginParams.appname = 'DESKTOP'

          Vue.ls.set(OPERATOR, null)
          const param = {}
          param.username = this.user.username
          param.login = true

          Login(loginParams).then(res => {
            if (res.success) {
              this.loginSuccess()
            }
          }).finally(() => state.loginBtn = false)
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    getCaptcha(e) {
      e.preventDefault()
      const { form: { validateFields }, state } = this
      validateFields(['mobile'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true
          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60
              state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)

          const hide = this.$message.loading('验证码发送中..', 0)
          getSmsCaptcha({ mobile: values.mobile }).then(res => {
            setTimeout(hide, 2500)
            this.$notification['success']({
              message: '提示',
              description: '验证码获取成功，您的验证码为：' + res.result.captcha,
              duration: 8
            })
          }).catch(err => {
            setTimeout(hide, 1)
            clearInterval(interval)
            state.time = 60
            state.smsSendBtn = false
          })
        }
      })
    },
    stepCaptchaSuccess(res) {
      this.loginSuccess(res)
    },
    stepCaptchaCancel() {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    loginSuccess() {
      const operator = Vue.ls.get(OPERATOR)
      if (operator.warehouses.length > 1) {
        this.$router.push({ name: 'warehouseSelect' }, () => {
          this.$message.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`
          })
        })
      } else {
        Vue.ls.set(ENTERPRISE, { id: operator.enterprise.id })
        Vue.ls.set(WAREHOUSE, operator.warehouses[0])
        this.$router.push({ name: 'statistics' }, () => {
          this.$message.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`
          })
        })
      }
      this.isLoginError = false
    }
  }
}
</script>

<style lang="less" scoped>
/* 登录容器 */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(to right, #3498db, #2c3e50);
  background-size: cover;
  position: relative;
}

.login-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: -1;
}

/* 登录表单 */
.main {
  width: 400px;
  background: rgba(255, 255, 255, 0.8);
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.title {
  display: block;
  text-align: center;
  font-size: 50px;
  color: #1890ff;
  font-weight: bold;
}

/* 登录输入框统一样式 */
.ant-input {
  border-radius: 8px;
  background: #f0f0f0;
  transition: all 0.3s ease;
  margin-bottom: 20px; /* 确保间距一致 */
  position: relative;
}

//.login-form-item{
//  border-color: #1890ff;
//  box-shadow: 0 0 10px rgba(24, 144, 255, 0.5);
//}
/* 前缀图标样式 */
.ant-input .ant-input-prefix {
  color: rgba(0, 0, 0, 0.25);
}

/* 标签样式 */
.ant-tabs {
  margin-bottom: 20px;
}

.ant-tabs-bar {
  .ant-tabs-tab {
    color: #666;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .ant-tabs-tab-active {
    color: #1890ff;
    font-weight: bold;
  }
}

/* 登录按钮 */
.login-button {
  width: 100%;
  height: 50px;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  background: linear-gradient(to right, #1890ff, #007bff);
  transition: all 0.3s ease;
}

.login-button:hover {
  background: #1890ff;
}

.login-button:active {
  background: #005cbf;
}

/* 错误提示 */
.ant-form-item-explain {
  color: red;
  font-size: 12px;
  margin-top: 5px;
}

</style>
